import { faListAlt } from '@fortawesome/free-regular-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosError } from 'axios'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import * as Yup from 'yup'
import { getOrders } from '../api/orderData'
import { moneyFormatter } from '../library/FormatUtil'
import DialogModal from './modals/DialogModal'

const searchValidationSchema = Yup.object()
  .shape({
    orderNumber: Yup.string()
    .required('Please enter an order number.')  
    .min(5, "Order number must  have at least 5 characters.")
    .max(20, "Order number must not exceed 20 characters."),


  });

export default function OrderSearchPage(props) {
  //let isSearch=true;
  const [isSearch, setIsSearch] = React.useState(true)
  const [message, setMessage] = React.useState('')
  const [orderDetails, setOrderDetails] = useState({})
  const [orderNumber, setOrderNumber] = useState('')
  const [puDate, setPuDate] = useState('')
  const [errorStatus, setErrorStatus] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [joblotStatus, setjoblotStatus] = useState(false);
  const [paymentsMade, setpaymentsMade] = useState({
    systemOrderType: '',                 
    systemOrderTypeIntID: 0,
    systemOrderNumber: '',     
    paymentTypeId: 0,     
    transactionId: 0,
    paymentDate: '',
    grandTotalAmount: 0
  });

  const [modalShow, setModalShow] = useState(false);
  const [isMessageHtml, setIsMessageHtml] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalMsg, setModalMsg] = useState('');

  const location = useLocation();
  const locationState = location.state;
  let isBackOrderNoAvailable = null;

  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
    reset} = useForm({
    resolver: yupResolver(searchValidationSchema),
  })
  const displayModal = false;
  const handleChange = (event) => {
    setOrderNumber({
      [event.target.name]: event.target.value.trim(),
    })
  }
  const handleKeyDown = (event) =>{
    if(event.key === "Enter"){
      const value = event.target.value.trim();
      setOrderNumber({[event.target.name]: value,});
      setValue('orderNumber', value, { shouldValidate: true });
      loadResults();
    }
  }

  const loadResults = async () => {
    const isValid = await trigger(); // Validate fields first
    //console.log("Form validation status:", isValid);
    if (isValid) handleSubmit(onSubmit)();
  };
  const onSubmit = async (data, e) => {
    //console.log('test orderNumber ', orderNumber, data.orderNumber)
    const moment = require('moment');
    let dateNow = moment().format("DD-MMM-YYYY HH:mm:ss");
    console.log("date now is: ", dateNow);
    let err_status = true;
    let _modalMsg = "";
    let _messageType = "";
    let paidAmount = 0;
    let paidDate = '';
    let paidTransactionId = 0;


    let _orderNum = orderNumber.orderNumber || data.orderNumber;
    let _puDate = puDate.puDate || data.puDate;
    setModalShow(true);
    setMessageType('loading');
    setModalTitle('Searching ...')
    let params = _orderNum;
    if(_puDate)
     params = _orderNum+"/"+_puDate

      await 
        getOrders(
          `${params}`
        )
        .then((response) => {
          // console.log(response)
          let req_status = (response instanceof AxiosError ) ? response.response?.status : response.status; 
          
            if( req_status === 200 ){ // If, status OK

          
              err_status = false;
              // console.log("response=",response)
              console.log('test response ', response.data);
              setIsSearch(false)
              //setjoblotStatus(response.data);
              
          
              // console.log('is job lot closed ', joblotStatus);
              
              let charges = response.data.charges;
              let paidInfo = response.data?.paymentTransaction;
              let isLotCLosed = response.data.isCFSLotStatusClosed;
              let orderStatus = response.data.orderStatus;
              let palletCount = response.data?.palletExchange||0;
              let isPalletPaid = response.data?.isPalletPaid || false;
              let totalAmountDue = response.data?.totalAmountDue || 0;
              let lotType = response.data?.systemOrderType;
              let palletCheckCond = false; // For TMSystem || CES || GO order  

              if(lotType === 'CMSSystem') { // For CFS Lots
                if( palletCount>0 ){
                  palletCheckCond = true;
                }
              }
              
              if( isLotCLosed && orderStatus !== "OPEN"){ // if Lot status is closed, show modal box
                _modalMsg = "File Lot "+_orderNum+" is closed.";
                _messageType = 'error';
              }else { // if Lot status is not closed
                if (totalAmountDue <= 0 && (!palletCheckCond || (palletCheckCond && isPalletPaid)) ) {
                  if(paidInfo === null){  // To fix UI Show empty model on search, Added if totalAmoutDue is lessthan or equal to zero. //
                    _modalMsg = 'No charges are available for this order.';
                    _messageType = 'error';
                  }
                  _modalMsg = `No charges are available for this order. `;
                  _messageType = 'success';
                      _messageType = 'success';
                  if(paidInfo != null)
                      if(paidInfo.grandTotalAmount > 0)
                     {                     
                      const formattedDate = moment(paidInfo.paymentDate).format('MM/DD/YYYY, h:mm A');
                      _modalMsg = `Payment for <b>${_orderNum}</b> was paid on 
                      <br/> <b class='text-primary'>${formattedDate}</b> for <b>${moneyFormatter.format(paidInfo.grandTotalAmount)}</b>
                      <br /><br /> Transaction Number : <b class='text-success'> ${paidInfo.transactionId} </b> `;
                      _messageType = 'success';
                      setIsMessageHtml(true);
                     }
                } else if (charges === null) {// if no charges present, show modal box
                  _modalMsg = 'No charges are available for this order.';
                  _messageType = 'error';
                } else { // charges found so display orderresults page
                      navigate('/orderresults', { state: response.data })
                }

              }
            }else if ( req_status===404 ){ // not found
              setErrorMessage('Order not found');
              _modalMsg = _orderNum + ` Order not found. Please use a different order number.`;
              _messageType = 'error';
            }else{  // If, status not 200
              _modalMsg = 'Sorry, there was an error.';
              _messageType = 'error';
            }
          
        })
      //await search(orderFormData);
      .catch(function (error) {
        setErrorMessage('Order not found');
        _modalMsg = _orderNum + ` Order not found. Please use a different order number.`;
        _messageType = 'error';
        console.log("err",error)
      })
      .finally(()=> {
        setModalTitle('Search Results');
        setModalMsg(_modalMsg);
        setMessageType(_messageType);
      });
  }

  const onError = (errors) => {
    
  }

  const handleModalClose = () => { 
    setModalShow(false);  
    setTimeout(() => {
      const input = document.getElementById("orderNumber");
      if (input) {
        input.value = '';
        input.focus();
      }
    }, 50);
    
  }



  function replaceHistory(e) {
    if (e) {
      e.preventDefault();

      delete e.returnValue;
    }

    window.history.replace({ ...window.history.location, state: undefined });
  }

  const [searchParams] = useSearchParams();
  let urlOrderNumber = searchParams.get('ordernumber');
  let urlPuDate = searchParams.get('pudate');
  useEffect(() => {
    
    let enteredOrderedNumber = locationState?.enteredOrderedNumber;
    let enteredpuDate = locationState?.enteredpuDate;
//console.log("enteredOrderedNumber",enteredOrderedNumber,locationState, urlOrderNumber)
    let orderNum = urlOrderNumber || enteredOrderedNumber || '' ;
    let puDate = urlPuDate || enteredpuDate || '' ;
    setValue('orderNumber', orderNum);
    setValue('puDate', puDate);
    if( urlOrderNumber ){
      // console.log("in loading results")
      // redirect to results page i valid joblot number sent through url
      const loadResults = async () => {
        const isValid = await trigger(); // Validate fields first
        //console.log("Form validation status:", isValid);
        if (isValid) handleSubmit(onSubmit)();
      };
  
      loadResults(); 
    }
  }, [locationState, urlOrderNumber])

   
  return (
    <>

            

    <div>
    <DialogModal modalShow={modalShow} modalTitle={modalTitle} messageType={messageType} modalMsg={modalMsg} handleModalClose={handleModalClose} isMessageHtml={isMessageHtml} />
      
       
      <div className='container content'>
      <div className="row">
         
        <div className="col-12 col-md-12 text-center pt-3">
          <h3 className='welcome-note pt-4'> 
            <strong> Welcome to STG ePay </strong> 
            </h3>
            <h6 className='text-muted pt-2 pl-2'>Your payment portal for STG Shipments</h6>
        </div>
      </div>
      
      <div className='row pb-14'>
        <div className='col-md-8 col-12 offset-md-2 pt-4'>
              <div className="card mb-4">
                <div className="card-header text-center"><h5 className="mb-0">SEARCH SHIPMENT</h5>
                {/* <span class="small ms-1">Please enter your order number to display order details</span> */}
                </div>
                <div className="card-body module-card-body">
                     

<form onSubmit={handleSubmit(onSubmit, onError)}>
<div className='row'>
    <div className='col-12 col-md-12'>
    <label className="form-label" htmlFor="exampleFormControlInput1">Please enter your order number to display order details </label>

                <div className="input-group">
                <span className="input-group-text" id="amount"><FontAwesomeIcon icon={faListAlt} /></span>
                <input
                    {...register('orderNumber')}
                    className='form-control form-control-sm '
                    onChange={handleChange}
                    title='To search for a TruckMate Freight Bill Number, please add a "TM" to the beginning of the Freight Bill number. Example: Freight Bill Number: 00000123 = TM00000123 .
                    To search for a Profit Tools shipment Number, please add a "PT" to the beginning of the shipment number.
Example: Shipment Number: 13085 = PT13085'
                    type='text' id='orderNumber'
                    placeholder='Enter Shipment Number' autoFocus
                    onKeyDown={handleKeyDown}
                  /> 

                  <span className="input-group-text">
                    <Button type='submit' variant='ghost' className='btn-sm text-white b-0'><FontAwesomeIcon icon={faSearch} /> Search</Button>
                     
                  </span>

                  <input
                    {...register('puDate')}
                    className='form-control form-control-sm '
                    title=''
                    type='hidden' id='puDate'
                    
                  /> 
                  
                </div>
                </div>
                  
                {errors.orderNumber && (
                    <div className='error-text'>
                      {errors.orderNumber.message}
                    </div>
                  )}
                  </div>
              </form>
              </div>
                       </div>
                    </div>
                        </div>
                      <div className='row pb-14'>
                        <div className='col-md-8 col-12 offset-md-2'>
                          <div className="smallOrderText">
                            {/* <div style={{fontSize: "16px", display:"flex", justifyContent: "center"}} className='text-danger'>ACH is currently under maintenance.</div>
                             <p style={{marginBottom: "10px"}}></p>                             */}
                            <strong className='text-danger'><u>Note : </u></strong>
                            <br />

                            <span className='text-muted'>To search for a TruckMate Freight Bill Number, please add a "TM" to the beginning of the Freight Bill number. <br />
                            <i>Example : Freight Bill Number : 00000123 = TM00000123 </i>
                            <p style={{marginTop: "10px"}}></p>
                            To search for a Profit Tools shipment Number, please add a "PT" to the beginning of the shipment number. <br />
                            <i>Example : Shipment Number : 13085 = PT13085 </i>
                            </span>
                          </div> 
                          </div>
                      </div> 
                      </div>
                    </div>
     
    </>
  )
}
